import { Col, Row, Space } from 'antd';
import React, { FC } from 'react';
import { ReactComponent as WorkatoLogo } from 'assets/svgs/workato-logo.svg';
import { Page } from 'components/molecules/page';
import { useTranslation } from 'hooks/use-translation';
import { IntegrationHeader, PageContent } from '../../components';
import { WorkatoForm } from './form';

export const Workato: FC = () => {
  const title = useTranslation('settings.integrations.workato.title');
  const description = useTranslation(
    'settings.integrations.workato.description',
  );

  return (
    <Page>
      <IntegrationHeader
        title={title}
        icon={<WorkatoLogo />}
        subText={description}
      />
      <PageContent>
        <Row>
          <Col xl={{ span: 15, offset: 5 }} span={24}>
            <Space direction="vertical" size={64}>
              <WorkatoForm />
            </Space>
          </Col>
        </Row>
      </PageContent>
    </Page>
  );
};
